import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Page, Group, Layout, Grid } from "@/comn/components";
import { useFetch, useGrid, useModal, usePage } from "@/comn/hooks"; // hook
import { APIS, SG_LPCO_FEE_HIST_LIST } from "@/tz/go/egaz/osci/lpco/fee/services/OsciLpcoFeeService"; // 서비스

export const OSCI0205012Q = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!

    const feeId = props?.state?.feeId;

    /*
     * Fee Change History List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        feeHistList: useGrid({
            defaultSchema: SG_LPCO_FEE_HIST_LIST,
        }),
    };

    /*
     * Fee Change History Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getLpcoFeeHistList: useFetch({
            api: () => APIS.getLpcoFeeHistList(feeId),
            onSuccess: () => {},
            onError: (error: any) => {
                const errmsg =
                    error.response?.data?.errorCode == -1 ? "msg.osc.00015" : error.response?.data?.errorMessage;
                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: false,
        }),
    };

    /*
     * Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: () => {
            if (feeId) {
                fetch.getLpcoFeeHistList.fetch();
            }
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    const render = {
        grid_feeHistList: {
            head: {},
            cell: {},
            edit: {},
            checkbox: (row: any) => {},
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"B_PRCSS_HIST"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group>
                            <Group.Body>
                                <Grid
                                    {...grid.feeHistList.grid}
                                    data={fetch.getLpcoFeeHistList.data?.feeHistList}
                                    render={render.grid_feeHistList}
                                />
                            </Group.Body>
                        </Group>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
